import { render, staticRenderFns } from "./StatusSettings.vue?vue&type=template&id=f925f73c"
import script from "./StatusSettings.vue?vue&type=script&lang=js"
export * from "./StatusSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports